import { Tooltip } from '@/components/Tooltip';
import { useMonitoringCountMode, MonitoringCountMode } from '@/hooks/useMonitoringCountMode';
import { cn } from '@/utils/classname';

interface MonitoringCountModeToggleProps {
  customerEmail: string;
}

const MODE_OPTIONS: Array<{
  value: MonitoringCountMode;
  label: string;
  tooltip: string;
}> = [
  {
    value: 'rolling-30d',
    label: '30 Day',
    tooltip:
      'Counts all active assets seen in the last 30 days. This is the legacy counting method and may include stale assets that are no longer being discovered.',
  },
  {
    value: 'last-scan',
    label: 'Last Scan',
    tooltip:
      'Counts only assets discovered during the most recent completed scan cycle. This reflects what is actively being monitored right now.',
  },
];

export function MonitoringCountModeToggle({
  customerEmail,
}: MonitoringCountModeToggleProps) {
  const { mode, handleToggle } = useMonitoringCountMode(customerEmail);

  return (
    <div className="inline-flex items-center gap-2">
      <span className="text-chariot-text-secondary text-xs font-medium">
        Count Mode:
      </span>
      <div className="bg-chariot-background-secondary border-chariot-stroke inline-flex rounded-md border">
        {MODE_OPTIONS.map(option => (
          <Tooltip key={option.value} title={option.tooltip}>
            <button
              type="button"
              onClick={() => handleToggle(option.value)}
              className={cn(
                'px-3 py-1 text-xs font-medium transition-colors',
                'first:rounded-l-[5px] last:rounded-r-[5px]',
                mode === option.value
                  ? 'bg-chariot-brand-primary text-white'
                  : 'text-chariot-text-secondary hover:text-chariot-text-primary hover:bg-chariot-background-tertiary'
              )}
            >
              {option.label}
            </button>
          </Tooltip>
        ))}
      </div>
    </div>
  );
}
